"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateCode = generateCode;
exports.getCodeList = getCodeList;
exports.updateCode = updateCode;
var _request = _interopRequireDefault(require("@/utils/request"));
function getCodeList(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/activation-codes',
    method: 'get',
    headers,
    params: query
  });
}
function generateCode(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/activation-codes/batch',
    method: 'post',
    headers,
    data
  });
}
function updateCode(token, id, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/activation-codes/limit/' + id,
    method: 'put',
    headers,
    data
  });
}